module.exports = __webpack_public_path__ + "img/icon-warning-flom-2.a8c9226e.svg";